import { render, staticRenderFns } from "./WordAnswer.vue?vue&type=template&id=184451bb&scoped=true&"
import script from "./WordAnswer.vue?vue&type=script&lang=js&"
export * from "./WordAnswer.vue?vue&type=script&lang=js&"
import style0 from "./WordAnswer.vue?vue&type=style&index=0&id=184451bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184451bb",
  null
  
)

export default component.exports